import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";

import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const INITIAL_FORM_DATA = {
  name: "",
  website: "",
  notes: "",
};

const SupplierForm = ({ workspaceId, setPopupShow, refreshList, selectedSupplier }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (selectedSupplier) {
      setFormData({
        name: selectedSupplier.name || "",
        website: selectedSupplier.website || "",
        notes: selectedSupplier.notes || "",
      });
      return;
    }
    setFormData(INITIAL_FORM_DATA);
  }, [selectedSupplier]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = { ...formData, workspace: workspaceId };

      if (selectedSupplier) {
        const res = await Utils._apiRequest({
          path: `${Enums.endpoints.supplierStock.SUPPLIERS}/${selectedSupplier._id}`,
          type: "PUT",
          payload,
        });
        if (res.errors) throw new Error(res.errors);
        toast.success("Cập nhật supplier thành công");
      } else {
        const res = await Utils._apiRequest({
          path: Enums.endpoints.supplierStock.SUPPLIERS,
          type: "POST",
          payload,
        });
        if (res.errors) throw new Error(res.errors);
        toast.success("Tạo supplier thành công");
      }

      refreshList();
      setPopupShow(false);
    } catch (error) {
      toast.error(error.message || "Lỗi khi lưu supplier");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="supplier-stock-form">
      <section className="supplier-stock-form__intro">
        <span className="supplier-stock-form__eyebrow">
          {selectedSupplier ? "Chỉnh sửa supplier" : "Tạo supplier mới"}
        </span>
        <h3>{selectedSupplier ? "Cập nhật thông tin supplier" : "Thêm supplier mới"}</h3>
        <p>Nhập thông tin nhà cung cấp cho workspace này.</p>
      </section>

      <section className="supplier-stock-form__section supplier-stock-form__meta">
        <Row className="g-3">
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Tên supplier *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="VD: PrintBase, CustomCat..."
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Website</Form.Label>
              <Form.Control
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                placeholder="https://..."
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Ghi chú</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Ghi chú về supplier..."
              />
            </Form.Group>
          </Col>
        </Row>
      </section>

      <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4 supplier-stock-form__actions">
        <Button
          variant="secondary"
          className="me-md-2"
          onClick={() => setPopupShow(false)}
          disabled={submitting}
          type="button"
        >
          Huỷ
        </Button>
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? "Đang lưu..." : "Lưu Supplier"}
        </Button>
      </div>
    </Form>
  );
};

export default SupplierForm;
